import { HttpService } from "./httpService";
import axiosInstance from "../config/axios";

export interface Category {
  id: string;
  name: string;
  imageUrl: string;
  products: string[]; // Array of product IDs
}

export interface CreateCategoryInput {
  name: string;
  imageUrl: string;
}

export interface UpdateCategoryInput {
  name?: string;
  imageUrl?: string;
}

export class CategoryService {
  static getAllCategories = async () => {
    return HttpService.get<Category[]>('/categories');
  };

  static getCategoryById = async (id: string) => {
    return HttpService.get<Category>(`/categories/${id}`);
  };

  static createCategory = async (category: CreateCategoryInput) => {
    return HttpService.post<Category>('/categories', category);
  };

  static updateCategory = async (id: string, category: UpdateCategoryInput) => {
    return HttpService.patch<Category>(`/categories/${id}`, category);
  };

  static deleteCategory = async (id: string) => {
    try {
      const response = await axiosInstance.delete(`/categories/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  static uploadCategoryImage = async (file: File) => {
    const formData = new FormData();
    formData.append('image', file);
    return HttpService.post<{ imageUrl: string }>('/upload/category-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  static addProductToCategory = async (categoryId: string, productId: string) => {
    return HttpService.post<Category>(`/categories/${categoryId}/products/${productId}`, {});
  };

  static removeProductFromCategory = async (categoryId: string, productId: string) => {
    return HttpService.delete<Category>(`/categories/${categoryId}/products/${productId}`);
  };
} 